import { GetOrgChartResponseJSON } from "@performyard/service-contracts";

import request from "./internal-base-request";

export const fetchOrgChart = async (): Promise<GetOrgChartResponseJSON> => {
	const [response] = await request<GetOrgChartResponseJSON>("/v1/org-chart");
	return response;
};
